import { Injectable } from '@angular/core';
import { forkJoin, Observable, of, switchMap } from 'rxjs';
import {
  ApplicationAppEntityApplicationRead,
  TreeToRemoveAppEntityTreeToRemoveRead,
  TreeToRemoveAppEntityTreeToRemoveWrite,
  TreeToRemoveService
} from '../openapi';
import { HttpClient } from "@angular/common/http";

export type ObjectTypeEnum = TreeToRemoveAppEntityTreeToRemoveWrite.ObjectTypeEnum;

export interface TreeSpeciesItem {
  gatunek_drzewa: string;
  cena_za_cm_do_100: string;
  cena_za_cm_powyzej_101: string;
}

export interface ShrubSpeciesItem {
  gatunek_krzew: string;
  pow_do_100m2: string;
  pow_powyzej_101m2: string;
}

@Injectable({
  providedIn: 'root'
})
export class TreeToRemoveCommonService {
  constructor(
    private treeToRemoveService: TreeToRemoveService,
    private http: HttpClient
  ) {
  }

  public updateTreesToRemove(items: TreeToRemoveAppEntityTreeToRemoveWrite[], application: ApplicationAppEntityApplicationRead): Observable<TreeToRemoveAppEntityTreeToRemoveRead[]> {
    const deleteRequests: Observable<any>[] = application.treesToRemove?.map(v => v.id || '').map(v => this.treeToRemoveService.deleteTreeToRemoveTreeToRemoveItem({id: v})) as Observable<any>[];
    return (deleteRequests.length ? forkJoin(deleteRequests) : of([])).pipe(
      switchMap(() => {
        return items.length ? forkJoin(items.map(treeToRemove => this.treeToRemoveService.postTreeToRemoveTreeToRemoveCollection({
              treeToRemove: {
                ...treeToRemove,
                removalFee: `${treeToRemove?.removalFee}`,
                application: application.uuid || ''
              }
            })
          )
        ) : of([]);
      })
    );
  }

  public loadTreeSpecies(): Observable<TreeSpeciesItem[]> {
    return this.http.get<TreeSpeciesItem[]>('/slownik_drzewa.json');
  }

  public loadShrubSpecies(): Observable<ShrubSpeciesItem[]> {
    return this.http.get<ShrubSpeciesItem[]>('/slownik_krzewy.json');
  }
}
